export default [
    /* {
        name: 'Paytone One',
        files: ['https://fonts.gstatic.com/s/paytoneone/v10/0nksC9P7MfYHj2oFtYm2ChTigPvfiwq-FQc.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
            unicodeRange: 'U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB',
        },
    },
    {
        name: 'Paytone One',
        files: ['https://fonts.gstatic.com/s/paytoneone/v10/0nksC9P7MfYHj2oFtYm2ChTjgPvfiwq-FQc.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
            unicodeRange:
                'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
        },
    },
    {
        name: 'Paytone One',
        files: ['https://fonts.gstatic.com/s/paytoneone/v10/0nksC9P7MfYHj2oFtYm2ChTtgPvfiwq-.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
            unicodeRange:
                'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
        },
    },*/
    {
        name: 'Limelight',
        files: ['https://fonts.gstatic.com/s/limelight/v8/XLYkIZL7aopJVbZJHDuoNOlHjHUmTUFt.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: 400,
            unicodeRange:
                'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
        },
    },
    {
        name: 'Limelight',
        files: ['https://fonts.gstatic.com/s/limelight/v8/XLYkIZL7aopJVbZJHDuoOulHjHUmTQ.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: 400,
            unicodeRange:
                'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
        },
    },
    {
        name: 'Autour One',
        files: ['https://fonts.gstatic.com/s/autourone/v7/UqyVK80cP25l3fJgbdfbo5BcV-UyZKAbcw.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
            unicodeRange:
                'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
        },
    },
    {
        name: 'Autour One',
        files: ['https://fonts.gstatic.com/s/autourone/v7/UqyVK80cP25l3fJgbdfbo55cV-UyZKA.woff2'],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
            unicodeRange:
                'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
        },
    },
];
